import { usePreloadImage } from "hooks/usePreloadImage";
import { INTRO_END_SPLASH_SRC } from "./introTutorialConsts";
import { BaseTutorial } from "../BaseTutorial";

export const IntroTutorial = (props) => {
  usePreloadImage(INTRO_END_SPLASH_SRC);

  return <BaseTutorial {...props} />;
};
